/**
 * Coure.RateBillingManagement.API 
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientResourceRate } from '../model/clientResourceRate';
import { ClientResourceRateMapDto } from '../model/clientResourceRateMapDto';
import { ClientResourceRateUnMapDto } from '../model/clientResourceRateUnMapDto';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientResourceRateService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param rateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateGetAllByRateIdGet(rateId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientResourceRate>>;
    public apiClientResourceRateGetAllByRateIdGet(rateId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientResourceRate>>>;
    public apiClientResourceRateGetAllByRateIdGet(rateId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientResourceRate>>>;
    public apiClientResourceRateGetAllByRateIdGet(rateId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateId !== undefined && rateId !== null) {
            queryParameters = queryParameters.set('rateId', <any>rateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientResourceRate>>('get',`${this.basePath}/api/ClientResourceRate/GetAllByRateId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ClientResourceRate>>;
    public apiClientResourceRateGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientResourceRate>>>;
    public apiClientResourceRateGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientResourceRate>>>;
    public apiClientResourceRateGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientResourceRate>>('get',`${this.basePath}/api/ClientResourceRate/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateGetByClientResourceIdGet(clientResourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientResourceRate>;
    public apiClientResourceRateGetByClientResourceIdGet(clientResourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResourceRate>>;
    public apiClientResourceRateGetByClientResourceIdGet(clientResourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResourceRate>>;
    public apiClientResourceRateGetByClientResourceIdGet(clientResourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientResourceId !== undefined && clientResourceId !== null) {
            queryParameters = queryParameters.set('clientResourceId', <any>clientResourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientResourceRate>('get',`${this.basePath}/api/ClientResourceRate/GetByClientResourceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceRateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateGetByIdGet(clientResourceRateId?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientResourceRate>;
    public apiClientResourceRateGetByIdGet(clientResourceRateId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResourceRate>>;
    public apiClientResourceRateGetByIdGet(clientResourceRateId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResourceRate>>;
    public apiClientResourceRateGetByIdGet(clientResourceRateId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientResourceRateId !== undefined && clientResourceRateId !== null) {
            queryParameters = queryParameters.set('clientResourceRateId', <any>clientResourceRateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientResourceRate>('get',`${this.basePath}/api/ClientResourceRate/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rateId 
     * @param clientResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateGetByRateIdClientResourceIdGet(rateId?: string, clientResourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientResourceRate>;
    public apiClientResourceRateGetByRateIdClientResourceIdGet(rateId?: string, clientResourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResourceRate>>;
    public apiClientResourceRateGetByRateIdClientResourceIdGet(rateId?: string, clientResourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResourceRate>>;
    public apiClientResourceRateGetByRateIdClientResourceIdGet(rateId?: string, clientResourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateId !== undefined && rateId !== null) {
            queryParameters = queryParameters.set('rateId', <any>rateId);
        }
        if (clientResourceId !== undefined && clientResourceId !== null) {
            queryParameters = queryParameters.set('clientResourceId', <any>clientResourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientResourceRate>('get',`${this.basePath}/api/ClientResourceRate/GetByRateIdClientResourceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateMapClientResourceRatePost(body?: ClientResourceRateMapDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiClientResourceRateMapClientResourceRatePost(body?: ClientResourceRateMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiClientResourceRateMapClientResourceRatePost(body?: ClientResourceRateMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiClientResourceRateMapClientResourceRatePost(body?: ClientResourceRateMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/ClientResourceRate/MapClientResourceRate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceRateUnMapClientResourceRatePost(body?: ClientResourceRateUnMapDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiClientResourceRateUnMapClientResourceRatePost(body?: ClientResourceRateUnMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiClientResourceRateUnMapClientResourceRatePost(body?: ClientResourceRateUnMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiClientResourceRateUnMapClientResourceRatePost(body?: ClientResourceRateUnMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/ClientResourceRate/UnMapClientResourceRate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
